module.exports = __webpack_public_path__ + "media/images/sp/top/google_review@3x-9fb335306f8c57d350d8805aa6cb88cd.webp";